module.exports = __webpack_public_path__ + "static/img/about_bg_05_zh3.df88cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_05_zh3.png
// module id = fk/D
// module chunks = 34